export const APPROVALS_ENGLISH = {
  "datox.approvals.title": "Approvals",
  "datox.approvals.description": "Track report review requests, reviewer decisions, and items waiting for attention.",
  "datox.approvals.total": "Total requests",
  "datox.approvals.pending": "Pending",
  "datox.approvals.approved": "Approved",
  "datox.approvals.rejected": "Rejected",
  "datox.approvals.search": "Search approvals…",
  "datox.approvals.filter.all": "All statuses",
  "datox.approvals.empty": "No approval requests found.",
  "datox.approvals.noMatches": "No approvals match your search or filter.",
  "datox.approvals.error": "Could not load approvals. Please try again.",
  "datox.approvals.retry": "Retry",
  "datox.approvals.refresh": "Refresh approvals",
  "datox.approvals.reviewer": "Reviewer",
  "datox.approvals.updated": "Updated",
  "datox.approvals.projectWide": "Project-wide report",
  "datox.approvals.open": "Open approval",
  "datox.approvals.back": "Back to approvals",
  "datox.approvals.workflow": "Open reporting workflow",
  "datox.approvals.status.pending": "Pending",
  "datox.approvals.status.approved": "Approved",
  "datox.approvals.status.rejected": "Rejected",
} as const
